module.exports = __webpack_public_path__ + "static/media/sculptureCorrect.2fd0984a.png";